<template>
  <div class="container">
    <ul v-if="detail != ''">
      <li>
        <label>批次编号：</label>
        <p>{{ detail.no }}</p>
      </li>
      <li>
        <label>出库日期： </label>
        <p>{{ detailVal.out_date }}</p>
      </li>
      <li>
        <label>操作人： </label>
        <p>{{ detailVal.user_name }}</p>
      </li>
      <li>
        <label>操作时间： </label>
        <p>{{ detailVal.create_time }}</p>
      </li>
    </ul>
    <table>
      <thead>
        <th>网点设备</th>
        <th>商品名称</th>
        <th>商品图</th>
        <th>出库类型</th>
        <th>出库数量</th>
      </thead>
      <tbody>
        <tr v-for="(item, index) in list" :key="index">
          <td>{{ item.device_name }}</td>
          <td>{{ item.brand_name }}</td>
          <td>
            <p v-show="item.out_type == 1">补货</p>
            <p v-show="item.out_type == 2">美陈</p>
          </td>
          <td>
            <img :src="item.imageUrl.url_thumb" alt="" />
          </td>
          <td>{{ item.num }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      detail: "",
      list: ""
    };
  },
  props: {
    detailVal: {}
  },
  watch: {
    detailVal() {
      this.getDetail();
    }
  },
  mounted() {
    if (this.detailVal != undefined) {
      this.getDetail();
    }
  },
  methods: {
    getDetail() {
      this.detail = this.detailVal;
      let url =
        this.httpsBasic.url +
        this.httpsBasic.equipment +
        "Project_out/getProjectOutDetail";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        project_out_id: this.detailVal.id
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.list = res.data.data;
          // console.log(this.detail);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  > ul {
    margin-top: 30px;
    > li {
      margin-bottom: 10px;
      p,
      label {
        display: inline-block;
        font-size: 14px;
        line-break: 20px;
      }
    }
  }
  table {
    td,
    th {
      border: 1px solid #ccc;
      padding: 4px 6px;
    }
    tr {
      img {
        height: 30px;
        width: 30px;
      }
    }
  }
}
</style>
